import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import MaintenanceTemplate, { MaintenanceTemplateProps } from '../../templates/Maintenance'

const MaintenancePage: React.FC = () => {
  const { t } = useTranslation()

  const templateProps: MaintenanceTemplateProps = useMemo(
    () => ({
      logo: {
        src: `${import.meta.env.BASE_URL}images/logo.png`,
        alt: t('header.logo.alt'),
      },
      background: `${import.meta.env.BASE_URL}images/home/background.jpeg`,
      title: t('maintenance.title'),
      text: t('maintenance.text'),
      cta: {
        text: t('maintenance.cta'),
        // A reload re-runs the app init, i.e. retries the essential queries.
        onClick: () => window.location.reload(),
      },
    }),
    [t]
  )

  return <MaintenanceTemplate {...templateProps} />
}

export default MaintenancePage
